import React, { PropsWithChildren } from 'react';
import theme from './BuyerPageTitle.module.scss';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { PageTitle } from '@/components/layout/PageTitle';
import { Trans } from '@lingui/react/macro';
import { classnames } from '@ygtechnologies/bygr-frontend-component-library';

interface BuyerPageTitleProps extends PropsWithChildren {
    transparent?: boolean;
    leftPadding?: boolean;
}

const BuyerPageTitle: React.FC<BuyerPageTitleProps> = ({ transparent, leftPadding }) => {
    const { projectData } = useSelector((state: IState) => state.buyer);
    const { sidebarMode } = useSelector((state: IState) => state.global);

    return (
        <PageTitle transparent={transparent}>
            <div
                className={classnames(theme.container, {
                    [theme.transparent]: transparent,
                    [theme.leftPadding]: leftPadding,
                })}>
                <span>
                    {projectData?.projectName} - {projectData?.unitName}
                </span>
                <small>
                    {projectData?.floor && (
                        <>
                            <span className={theme.muted}>
                                <Trans>Floor</Trans>:
                            </span>{' '}
                            {projectData?.floor}
                        </>
                    )}
                    {projectData?.address && <span className={theme.muted}>{projectData?.address}</span>}
                </small>
            </div>
        </PageTitle>
    );
};

export default BuyerPageTitle;
